import * as React from 'react'
import Icon from '../Icon/Icon'

export interface ICardButtonProps {
  label: string
  variant?: string // can be button to have arrow icon
  onClick?: any // required if variant is button
  idForLabel?: string // If we have an input, this will link the label with the input
}

const CardButton: React.SFC<ICardButtonProps> = ({
  onClick,
  label,
  variant,
  idForLabel,
  children,
}) => {
  let buttonToDisplay: any
  if (variant === 'button') {
    buttonToDisplay = (
      <div className="CardButton CardButton--button">
        <button className="CardButton-content" onClick={onClick}>
          <span>{label}</span>
          <Icon name="deplier" />
        </button>
      </div>
    )
  } else if (variant === 'skipit') {
    buttonToDisplay = (
      <button className="CardButton-skip" onClick={onClick}>
        <span>{label}</span>
        <Icon name="arrowright" />
      </button>
    )
  } else if (variant === 'input') {
    buttonToDisplay = (
      <div className="CardButton CardButton--input">
        {children}
        <label className="CardButton-content" htmlFor={idForLabel}>
          <span>{label}</span>
        </label>
      </div>
    )
  } else if (variant === 'money') {
    buttonToDisplay = (
      <div className="CardButton CardButton--money">
        <Icon name="money" />
        <span>{label} €</span>
      </div>
    )
  } else if (variant === 'response' || variant === '') {
    buttonToDisplay = (
      <div className="CardButton CardButton--response">
        <div className="CardButton-content">
          <span>{label}</span>
        </div>
      </div>
    )
  }

  return <>{buttonToDisplay}</>
}

export default CardButton



// WEBPACK FOOTER //
// ./src/components/CardButton/CardButton.tsx